import { render } from "./Settings.vue?vue&type=template&id=d720f55c&scoped=true&bindings={}"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=d720f55c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d720f55c"

export default script